/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmTarget {
    getFixupPrototypeFunction() { return AwsSsmTarget.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmTarget>): AwsSsmTarget {
        let obj = Object.assign(new AwsSsmTarget(), model);
        AwsSsmTarget.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmTarget>): AwsSsmTarget {
        if (!model) return null;
        return AwsSsmTarget.newInstance(<AwsSsmTarget> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmTarget) {
        if (!obj) return;

        models.AwsSsmTarget.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmTarget): boolean {
        Object.setPrototypeOf(obj, AwsSsmTarget.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Type of the target resource for execution of command document
     */
    key: string;

    /**
     * Target resource details
     */
    values: Array<string>;

}
